"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _constants = require("./constants");

var ContactList =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(ContactList, _Record);

  function ContactList(_ref) {
    var list = _ref.list;
    (0, _classCallCheck2.default)(this, ContactList);
    var size = list.metaData.size;
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ContactList).call(this, (0, _extends2.default)({
      listSize: size
    }, list)));
  }

  return ContactList;
}((0, _immutable.Record)({
  name: null,
  listSize: null,
  listId: null
}, _constants.CONTACT_LISTS));

exports.default = ContactList;
module.exports = exports.default;